import Vue from "vue";
import RepositoryResponse from "@/interfaces/Repository/RepositoryResponse";
import { getRepositoryResponse } from "@/helpers/Repositories/RepositoryHelpers";
import Booking from "@/interfaces/Contracts/Booking";
import BookingSite from "@/interfaces/Contracts/BookingSite";
import BookingsRepoFilter from "@/interfaces/Repository/Contracts/BookingsRepoFilter";

const END_POINT = "api/customerPortal/v1/bookings";

export async function getBookings(
  filter: BookingsRepoFilter
): Promise<RepositoryResponse> {
  let repositoryResponse = {} as RepositoryResponse;

  const getRequestParameters = {
    status: filter.status,
    fromEffectiveDate: filter.fromEffectiveDate,
    toEffectiveDate: filter.toEffectiveDate,
    fromExpireDate: filter.fromExpireDate,
    toExpireDate: filter.toExpireDate,
  };

  await getRepositoryResponse(END_POINT, getRequestParameters).then(
    (response) => (repositoryResponse = response)
  );

  return repositoryResponse;
}

export async function getBooking(
  bookingId: string,
  itemId: string,
  effective: Date
): Promise<Booking> {
  const response = await Vue.axios.get(
    `${END_POINT}/${bookingId}/${itemId}/${effective}`
  );

  return response.data as Booking;
}

export async function getBookingSites(
  bookingId: string,
  itemId: string,
  effective: Date
): Promise<BookingSite[]> {
  const response = await Vue.axios.get(`${END_POINT}/sites`, {
    params: {
      bookingId: bookingId,
      itemId: itemId,
      effectiveDate: effective,
    },
  });

  return response.data as BookingSite[];
}
